import { useSelector } from 'react-redux';
import { createSpecificTitlebarInputSelector } from '../redux/pages/selectors';

const useTitleBarInput = (inputKey: string) => {
  const inputValueSelector = createSpecificTitlebarInputSelector(inputKey);
  const relevantInput = useSelector(inputValueSelector);
  return relevantInput;
};
export default useTitleBarInput;
